/* ============
 * Stock Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './product';

export default class StockProductTransformer extends Transformer {

  static fetch(stock) {
    return {
      id: stock.id,
      qty: stock.qty,
      product_id: stock.product_id,
      batchId: stock.batch_id,
      physicalCount: stock.physical_count,
      currentCount: stock.current_count,
      variance: stock.variance,
      stock_id: stock.stock_id,
      product: stock.product !== undefined ? productTrans.fetch(stock.product) : [],
    };
  }

  static send(stock) {
    const productId = typeof stock.productId === 'object' ? stock.productId.id : stock.productId;
    return {
      qty: stock.qty,
      id: productId,
      batch_id: stock.batchId,
      variance: stock.variance,
      physical_count: stock.physicalCount,
      current_count: stock.currentCount,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/stockProduct.js